<template>
  <b-row>
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.agreements.form.agreementsDevices")}}: </span>
    </b-col>
    <b-col>
      <template v-if="data.packageDevices && data.packageDevices.length > 0">
        <b-row v-for="(item, index) in data.packageDevices" :key="index">
          <b-col>
            <model-select v-model="data.packageDevices[index].device" :options="devicesOptions" :placeholder="$t('views.agreements.form.select')" required class="mb-3" name="item">
            </model-select>
          </b-col>
          <b-col>
            <button type="button" class="btn btn-danger" @click="removeDevice(index)">{{ $t('buttons.delete') }}</button>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <b-button class="btn btn-primary" @click="addNewDevice()">{{ $t('views.agreements.form.addNewDevice') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import remove from '@/utils/remove'

export default {
  name: 'PackageDevices',
  components: {
    ModelSelect
  },

  props: ['data', 'violations'],

  computed: {
    ...mapGetters({
      devicesOptions: 'packages/list/getDevices'
    })
  },

  created () {
    this.fetchDevices()
  },

  methods: {
    addNewDevice () {
      let item = {}
      this.data.packageDevices.push(item)
    },
    removeDevice (index) {
      let currentDevice = this.data.packageDevices[index]
      if (currentDevice['@id']) {
        remove(currentDevice['@id'], () => {
          this.data.packageDevices.splice(index, 1)
        })
      } else {
        this.data.packageDevices.splice(index, 1)
      }
    },
    ...mapActions({
      fetchDevices: 'packages/list/fetchDevices'
    })
  }
}
</script>
